/**
 * CA-REVEAL — Scroll-reveal animation observer
 * Adds .ca-reveal--visible when elements with .ca-reveal enter the viewport.
 * Also auto-adds .ca-reveal to known product-page elements (stimmungsbild).
 * Fires once per element, then disconnects.
 */
(function () {
  /* Auto-tag elements that should animate but can't have classes in Liquid */
  var autoReveal = document.querySelectorAll(
    '[id*="stimmungsbild"] .banner'
  );
  autoReveal.forEach(function (el) {
    el.classList.add('ca-reveal');
  });

  /* Reduced-motion: skip animations, show everything immediately */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.ca-reveal').forEach(function (el) {
      el.classList.add('ca-reveal--visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ca-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
  );

  document.querySelectorAll('.ca-reveal').forEach(function (el) {
    observer.observe(el);
  });
})();
